import SetupComponent from 'App/babel/SetupRootComponent';
import BillingRoot from 'Components/Billing/BillingRoot';
import PreviewPdf from 'Components/Admin/DocumentTemplate/PreviewPdf';
import TemplateEditor from 'Components/Admin/DocumentTemplate/TemplateEditor';
import { checkPortedResolve } from 'App/helpers/angularRouteHelpers';

angular.module('domain.admin', ['ngRoute', 'upResources', 'security.authorization']).config([
	'$stateProvider',
	'$upModalProvider',
	function ($stateProvider, $upModalProvider) {
		// BASE PATH
		$stateProvider.state('administration', {
			abstract: true,
			controller: 'AdminCtrl as AdminCtrl',
			templateUrl: require('App/upsales/domain/admin/views/main.html?file'),
			url: '/:customerId/up-admin',
			section: 'admin',
			resolve: {
				loaded: [
					'AppService',
					function (AppService) {
						return AppService.loadedPromise;
					}
				]
			}
		});

		var isAdmin = function ($q, AppService) {
			var defer = $q.defer();

			// eslint-disable-next-line promise/catch-or-return
			AppService.loadedPromise.then(function () {
				if (AppService.getSelf().administrator) {
					return defer.resolve(true);
				}
				defer.reject();
			});

			return defer.promise;
		};
		isAdmin.$inject = ['$q', 'AppService'];

		const isProjectAdmin = function ($q, AppService) {
			const defer = $q.defer();

			// eslint-disable-next-line promise/catch-or-return
			AppService.loadedPromise.then(function () {
				if (AppService.getSelf().projectAdmin) {
					return defer.resolve(true);
				}
				defer.reject();
			});

			return defer.promise;
		};
		isProjectAdmin.$inject = ['$q', 'AppService'];

		const isAdminOrProjectAdmin = function ($q, AppService) {
			return $q
				.all({
					isAdmin: isAdmin($q, AppService).catch(() => false),
					isProjectAdmin: isProjectAdmin($q, AppService).catch(() => false)
				})
				.then(({ isAdmin, isProjectAdmin }) => {
					return isAdmin || isProjectAdmin;
				});
		};
		isAdminOrProjectAdmin.$inject = ['$q', 'AppService'];

		var isAdminAndCrm = function ($q, FeatureHelper, AppService) {
			return $q.all({
				isAdmin: isAdmin($q, AppService),
				hasCrm: FeatureHelper.isAvailableProductPromise(FeatureHelper.Product.CRM)
			});
		};
		isAdminAndCrm.$inject = ['$q', 'FeatureHelper', 'AppService'];

		var genericSubview = require('App/upsales/domain/admin/views/sub.html?file');
		var genericSubctrl = 'AdminSubCtrl as AdminSubCtrl';

		$stateProvider
			.state('administration.dashboard', {
				url: '/'
			})
			.state('administration.imports', {
				controller: genericSubctrl,
				templateUrl: genericSubview,
				url: '/import',
				section: 'admin',
				params: { stepId: null },
				resolve: {
					isAdmin: isAdmin
				}
			})
			.state('administration.import', {
				controller: 'ImportCtrl as AdminSubCtrl',
				templateUrl: genericSubview,
				url: '/import/:id',
				section: 'admin',
				params: { stepId: null, isNew: false },
				resolve: {
					isAdmin: [
						'$q',
						'AppService',
						function ($q, AppService) {
							return checkPortedResolve('administration.import', () => {
								return isAdmin($q, AppService);
							});
						}
					]
				}
			})
			.state('administration.profile', {
				url: '/profile'
			})
			.state('administration.user', {
				controller: 'EditUserCtrl as AdminSubCtrl',
				templateUrl: genericSubview,
				url: '/user/:id',
				section: 'admin',
				resolve: {
					isAdmin: isAdmin
				}
			})
			.state('administration.activityTypes', {
				url: '/activitytypes'
			})
			.state('administration.scripts', {
				template: '<div></div>',
				url: '/scripts',
				section: 'admin',
				resolve: {
					isAdmin: isAdmin
				}
			})
			.state('administration.script', {
				template: '<div></div>',
				url: '/script/:id',
				section: 'admin',
				resolve: {
					isAdmin: isAdmin
				}
			})
			.state('administration.integration', {
				controller: 'ConfigureIntegration as AdminSubCtrl',
				templateUrl: genericSubview,
				url: '/integrations/configure/:id/:configure?code?setOauthToNull?tab?oAuthFieldName',
				section: 'admin'
			})
			.state('administration.trigger', {
				controller: 'EditTrigger as AdminSubCtrl',
				templateUrl: genericSubview,
				section: 'admin',
				url: '/trigger/:id',
				resolve: {
					isAdminOrProjectAdmin: isAdminOrProjectAdmin,
					isAvailable: [
						'FeatureHelper',
						'AppService',
						function (FeatureHelper, AppService) {
							return checkPortedResolve('administration.trigger', () => {
								return AppService.loadedPromise.then(() => {
									if (AppService.getSelf().projectAdmin) {
										return true;
									}
									return FeatureHelper.isAvailablePromise(FeatureHelper.Feature.TRIGGERS);
								});
							});
						}
					]
				}
			})
			.state('administration.salesboards', {
				url: '/salesboards'
			})
			.state('administration.phonecallgoals', {
				url: '/phonecall-goals'
			})
			.state('administration.bookedappointmentgoals', {
				url: '/booked-appointment-goals'
			})
			.state('administration.completedappointmentgoals', {
				url: '/completed-appointment-goals'
			})
			.state('administration.optIn', {
				url: '/optin'
			});

		// MAIN
		$stateProvider
			.state('admin', {
				abstract: true,
				controller: 'Admin as Admin',
				section: 'admin',
				templateUrl: require('App/upsales/domain/admin/views/admin.html?file'),
				url: '/:customerId/admin',
				resolve: {
					authUser: [
						'$routeGuard',
						function ($routeGuard) {
							return $routeGuard.requireUser();
						}
					]
				}
			})
			// SALESBOARDS
			.state('admin.salesboards', {
				url: '/salesboards'
			})
			.state('admin.salesboard', {
				url: '/salesboard/:id'
			})
			.state('admin.settings', {
				controller: 'Settings',
				templateUrl: require('App/upsales/domain/admin/views/settings/settings.html?file'),
				url: '/settings',
				resolve: {
					authAdmin: [
						'$routeGuard',
						function ($routeGuard) {
							return $routeGuard.requireAdmin();
						}
					]
				}
			})
			.state('administration.billing', {
				template: '<div id="admin-billing-root"></div>',
				controller: [
					'$scope',
					'$element',
					'$stateParams',
					function ($scope, $element, $stateParams) {
						SetupComponent($scope, BillingRoot, $element[0], { initialTab: $stateParams.initialTab });
					}
				],
				params: {
					alias: null,
					initialTab: null
				},
				reloadOnSearch: false,
				url: '/billing/:initialTab?/?alias',
				section: 'admin',
				resolve: {
					authAdmin: [
						'$routeGuard',
						function ($routeGuard) {
							return $routeGuard.requireBillingAdmin();
						}
					]
				}
			})
			.state('administration.optOut', {
				url: '/optOut'
			})
			.state('administration.accountsettings', {
				url: '/accountsettings'
			})
			.state('administration.sharedAppointmentAvailabilitySettings', {
				url: '/shared-appointment-availability/:id'
			})

			.state('administration.reminders', {
				url: '/reminders'
			})
			.state('administration.mailsignature', {
				url: '/mailSignature'
			})
			.state('administration.singleSignOn', {
				template: '<div></div>',
				controller: [
					'$scope',
					'$element',
					function ($scope, $element) {
						SetupComponent($scope, window.SingleSignOn, $element[0], {}, { redux: true });
					}
				],
				url: '/single-sign-on',
				section: 'admin',
				resolve: {
					isAvailable: [
						'FeatureHelper',
						function (FeatureHelper) {
							return FeatureHelper.isAvailablePromise(FeatureHelper.Feature.SINGLE_SIGN_ON);
						}
					],
					authAdmin: [
						'$routeGuard',
						function ($routeGuard) {
							return $routeGuard.requireAdmin();
						}
					]
				}
			})
			.state('administration.notificationCenter', {
				url: '/notification-center'
			})
			.state('administration.defaultMailSignature', {
				url: '/default-mail-signature'
			});

		// Modals
		$upModalProvider
			.modal('AnonymizeContactAction', {
				template: '<div></div>',
				controller: function (
					$scope,
					$element,
					$modalParams,
					AppService,
					ContactAttributes,
					ActivityAttributes,
					AppointmentAttributes,
					OrderAttributes,
					OpportunityAttributes,
					MailAttributes,
					EventAttributes,
					AgreementAttributes
				) {
					window.AnonymizeContactController(
						$scope,
						$element,
						$modalParams,
						AppService,
						ContactAttributes,
						ActivityAttributes,
						AppointmentAttributes,
						OrderAttributes,
						OpportunityAttributes,
						MailAttributes,
						EventAttributes,
						AgreementAttributes
					);
				}
			})
			.modal('AddProductCategoryModal', {
				template: '<div id="addProductCategoryModal_root"></div>',
				controller: 'AddProductCategoryModal as AddProductCategoryModal',
				style: 'form-sm default modal400 scroll-y',
				resolve: {
					isAdminAndCrm: isAdminAndCrm
				}
			})
			.modal('PreviewTemplate', {
				template: '<div id="addProductModal_root"></div>',
				controller: [
					'$scope',
					'$element',
					'$modalParams',
					function ($scope, $element, $modalParams) {
						SetupComponent(
							$scope,
							PreviewPdf,
							$element[0],
							{
								pdfUrl: $modalParams.pdfUrl,
								upModal: $modalParams.upModal,
								pdfTemplateResource: $modalParams.pdfTemplateResource
							},
							{ redux: true, modal: true }
						);
					}
				],
				style: 'default pdf-preview PreviewPdfModal'
			})
			.modal('templateEditor', {
				template: '<div></div>',
				controller: function ($scope, $element, $modalParams) {
					SetupComponent($scope, TemplateEditor, $element[0], $modalParams, {
						modal: true,
						redux: true
					});
				},
				invisibleCurtain: true,
				style: 'form-wide default new-full-screen no-padding'
			});
	}
]);
